import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { TimeZoneService } from './time-zone.service';
import {
  TIMEZONE_CONFIG_TOKEN,
  TimeZoneConfig,
  timeZoneInitializerFactory,
} from './types';
import { TimeZoneConfigService } from './time-zone.config.service';

@NgModule()
export class TimeZoneModule {
  static forRoot(config: TimeZoneConfig): ModuleWithProviders<TimeZoneModule> {
    return {
      ngModule: TimeZoneModule,
      providers: [
        TimeZoneConfigService,
        {
          provide: TIMEZONE_CONFIG_TOKEN,
          useValue: config,
        },
        provideAppInitializer(() => {
        const initializerFn = (timeZoneInitializerFactory)(inject(TimeZoneConfigService), inject(TIMEZONE_CONFIG_TOKEN));
        return initializerFn();
      }),
        TimeZoneService,
      ],
    };
  }
}
